import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const helpers = createMultiStyleConfigHelpers(['root', 'tab', 'tablist', 'tabpanels', 'tabpanel']);

export const Tabs = helpers.defineMultiStyleConfig({
  variants: {
    'left-menu': {
      root: {
        h: 'full',
        display: 'flex',
        flexDirection: 'column',
      },
      tablist: {
        h: '2.32rem',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'inherit',
      },
      tab: {
        fontSize: 'sm',
        fontWeight: 'semibold',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'transparent',
        marginBottom: '-2px',
        textTransform: 'capitalize',
        _focus: {
          boxShadow: 'inset var(--vg-shadows-outline)',
        },
        '&[aria-selected="true"]': {
          color: 'blue.600',
          borderColor: 'currentcolor',
        },
        '&[data-selected]': {
          color: 'blue.600',
          borderColor: 'currentcolor',
        },
      },
      tabpanels: {
        height: 0,
        flexGrow: 1,
      },
      tabpanel: {
        p: 0,
        h: 'full',
        _focus: {
          boxShadow: 'inset var(--vg-shadows-outline)',
        },
      },
    },
    'sub-menu': {
      root: {
        h: 'full',
        display: 'flex',
        flexDirection: 'column',
      },
      tablist: {
        border: 0,
        marginBottom: '3',
      },
      tab: {
        fontSize: 'sm',
        fontWeight: 'medium',
        borderRadius: 'base',
        height: '8',
        paddingY: '1',
        paddingX: '3',
        _selected: {
          color: 'upgrade.700',
          bgColor: 'hover.blue',
        },
        _focus: {
          boxShadow: 'inset var(--vg-shadows-outline)',
        },
      },
      tabpanels: {
        height: 0,
        flexGrow: 1,
      },
      tabpanel: {
        p: '2px', // For shadows outline
        _focus: {
          boxShadow: 'inset var(--vg-shadows-outline)',
        },
      },
    },
  },
  baseStyle: {
    tab: {
      _selected: {
        bgColor: 'var(--vg-colors-hover-blue)',
      },
    },
  },
});
